/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function addGift(variantName) {
  fetch('/cart/add.js', {
    body: JSON.stringify({
      'id': 32371349389445, /* Geschenkverpackung */
      'quantity': 1,
      'properties': {'Box für': variantName}
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    method: 'POST'
  })
    .then(function(response) {
      if (response.ok) {
        // Handle success, such as showing a success message or updating the cart total
        console.log('Item added to cart successfully!');
 // Wait for 2 seconds
      setTimeout(function() {
        // Reload the cart page
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 1000);
        console.error('Error adding item to cart:', response.status, response.statusText);
        return response.json().then(function(errorData) {
          console.error('Error details:', errorData);
        });
      }
    })
    .catch(function(error) {
      console.error('Error adding item to cart:', error);
    });
}


document.addEventListener('variant:add', function(event) {
    var cart = event.detail.cart;
    var variantName = cart.items[0].title;
    var addBox = cart.items[0].properties._Geschenkbox;
    console.log("cart:", cart.items[0].properties._Geschenkbox, "detail:", cart.items[0].title );
    if (addBox === "Ja") {addGift(variantName)};
  });
